module.exports = __webpack_public_path__ + "img/icn_bucket.5502f115.svg";